import { put, call } from "redux-saga/effects";
import { resetApiError, riseError } from "store/features/general/general.actions";
import { fetchCreativeMappingsFields } from "./filters.actions";
import { FilterFields, getFilterFields } from "api";

export function* fetchCreativeMappingsFieldsSaga(headers: HeadersInit): Generator {
    try {
        const fields = (yield call(getFilterFields, headers)) as FilterFields[];

        yield put(
            fetchCreativeMappingsFields.success({
                fields,
            })
        );
    } catch (err) {
        if (err.status) {
            yield put(fetchCreativeMappingsFields.failure({ statusCode: err.status }));
            yield put(resetApiError());

            return;
        }

        yield put(riseError(err));
    }
}
